import styles from "./ToggleButton.module.css";

export default function ToggleButton({
    onClick,
    value,
    animated = false,
    active = false,
    children,
    style = {},
}) {
    return (
        <button
            value={value}
            style={style}
            onClick={onClick}
            className={`${styles.button} ${
                animated ? styles[`animated-option`] : ""
            } ${active ? styles[`button-active`] : ""}`}
        >
            {children}
        </button>
    );
}
